module.exports = __webpack_public_path__ + "img/stock3.37c726a2.png";